const SPOT_SORTING = [
  { label: 'NAME', value: 'fullName', isDefault: true },
  { label: 'FISCALCODE', value: 'fiscalCode' },
  { label: 'LAST_CALL_DATE', value: 'lastCallCompletedOn' },
];

export default SPOT_SORTING;
